module.exports = __webpack_public_path__ + "static/RHarwood_UX_Writing_Fundamentals_Certificate.f7dd2da0.png";


//////////////////
// WEBPACK FOOTER
// ./static/pdf/RHarwood_UX_Writing_Fundamentals_Certificate.png
// module id = 1211
// module chunks = 134156019343167